import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useErrorMessage } from '@nucleus-commerce/admin-kit/errors';
import type { ImportKind } from '@nucleus-commerce/api-client/admin';
import { toast } from '@nucleus-commerce/ui/components/sonner';

import { saveFile } from '@/shared/browser/save-file';

import { importsApi } from '../api/imports-api';

/** Fetched through the API client for the same reason as an export download: the cookie session. */
export function useDownloadSample(storeId: string) {
  const { t } = useTranslation('importsExports');
  const message = useErrorMessage();
  return useMutation({
    mutationFn: async (kind: ImportKind) => {
      const file = await importsApi.sample(storeId, kind);
      saveFile(file.filename, file.blob);
    },
    meta: { silentError: true },
    onError: (error) => {
      toast.error(t('import.sampleFailed'), { description: message(error) });
    },
  });
}
